import React, { Component } from "react";
import { profile, GET, PUT, alert, loading } from "./CustomComponent.js";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Sidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import LOGO from "../assets/images/logo-w.png";
import "../assets/css/bootstrap.css";
export default class NavbarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  icon = (io) => <span className="icon">{io}</span>;

  componentDidMount = async () => {
  };
  render() {
    return (
      <div className="w-100 p-5 bg-primary text-white">
        <div className="container mx-auto px-4">
          <div className="row">
            <div className="col-12 col-md-6 mb-5">
              <img className="mb-4" alt="logo-w" src={LOGO} width={200}/>
              <div className="w-75">
                เราคือผู้เชี่ยวชาญด้านเทคโนโลยีที่พร้อมช่วยองค์กรของคุณตั้งแต่การวิเคราะห์ระบบ วางแผน พัฒนา Web App, Mobile App, POS, IoT และ Cloud Platform รวมถึงการออกแบบ UX/UI ที่ใช้งานง่าย ตอบโจทย์ผู้ใช้จริง
              </div>
            </div>
            <div className="col-12 col-md-3 mb-5">
              <h5 className="fw-bold mb-3">สำรวจ</h5>
              <div className="mb-3"><a className="text-white text-decoration-none" href="/about">เกี่ยวกับเรา</a></div>
              <div className="mb-3"><a className="text-white text-decoration-none" href="/service">บริการ</a></div>
              <div className="mb-3"><a className="text-white text-decoration-none" href="/work">ผลงาน</a></div>
              <div className="mb-3"><a className="text-white text-decoration-none" href="/contact">ติดต่อเรา</a></div>
              <div className="mb-3"><a className="text-white text-decoration-none" href="/policy-privacy">Privacy Policy</a></div>
            </div>
            <div className="col-12 col-md-3 mb-5">
              <h5 className="fw-bold mb-3">ติดต่อเรา</h5>
              <div className="mb-3"><span className="icon me-2">{"\uf0e0"}</span><a className="text-white text-decoration-none" href={`mailto:${global.email}`}>{global.email}</a></div>
              
          </div>
          </div>
        </div>
      </div>
    );
  }
}
